import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Line from '../../../../../components/pdf/Line'
import { TableHeadText } from '../../../../../components/pdf/TableHelpers'
import { useFormReply } from '../../_load/FormReplyLoader'
import {
  findReplyByQuestionId,
  getReplyValue,
  toDateFormat,
  formatCNPJ,
  statePreposition,
  getContractorData,
  getContractorCNPJ,
  signatureText
} from '../../_helpers/pdfHelpers'

const TerminationContent = () => {
  const { replies } = useFormReply()

  const businessName = getReplyValue(findReplyByQuestionId(replies, 139))
  const cnpj = formatCNPJ(getReplyValue(findReplyByQuestionId(replies, 141)))
  const address = getReplyValue(findReplyByQuestionId(replies, 142))
  const street = getReplyValue(findReplyByQuestionId(replies, 193))
  const addressNumber = getReplyValue(findReplyByQuestionId(replies, 246))
  const neighborhood = getReplyValue(findReplyByQuestionId(replies, 214))
  const complement = getReplyValue(findReplyByQuestionId(replies, 195))
  const city = getReplyValue(findReplyByQuestionId(replies, 196))
  const postalCode = getReplyValue(findReplyByQuestionId(replies, 143))
  const legalRepresentativeName = getReplyValue(findReplyByQuestionId(replies, 153))
  const nationality = getReplyValue(findReplyByQuestionId(replies, 154))
  const maritalStatus = getReplyValue(findReplyByQuestionId(replies, 155))
  const rg = getReplyValue(findReplyByQuestionId(replies, 160))
  const orgaoEmissor = getReplyValue(findReplyByQuestionId(replies, 162))
  const cpf = getReplyValue(findReplyByQuestionId(replies, 158))
  const legalRepresentativeEmail = getReplyValue(findReplyByQuestionId(replies, 168))
  const now = toDateFormat(new Date(), 'D [de] MMMM [de] YYYY')
  const contractorCNPJ = getContractorCNPJ(findReplyByQuestionId(replies, 138))
  const contractorData = getContractorData(findReplyByQuestionId(replies, 138))
  const startDate = getReplyValue(findReplyByQuestionId(replies, 169))
  const endDate = getReplyValue(findReplyByQuestionId(replies, 178))

  const getState = () => {
    if (address?.state) {
      return `${address.state}`
    }
    let state = getReplyValue(findReplyByQuestionId(replies, 197))
    if (!state) {
      state = getReplyValue(findReplyByQuestionId(replies, 245)).name || ''
    }
    return state
  }

  const getStreetNumber = () => {
    let number = getReplyValue(findReplyByQuestionId(replies, 194))
    if (number) {
      return `nº ${number}`
    }
    number = getReplyValue(findReplyByQuestionId(replies, 246))
    if (number) {
      return `nº ${number}`
    }
    if (address?.number) {
      return `nº ${address.number}`
    }
    if (address && !address.number) {
      try {
        const st1 = address.search.indexOf(',') + 1
        const st2 = address.search.indexOf(' - ')
        const value = address.search.substring(st1, st2)
        if (Number(value)) {
          return `nº ${value}`
        }
        return 'sem número'
      } catch (e) {
        return 'sem número'
      }
    }
    return addressNumber
  }

  const addressData = () => {
    if (address) {
      return (
        <>
          e do outro lado, <b> {businessName} </b>, inscrita no CNPJ/MF sob o nº {cnpj} com sede na {address.address},{' '}
          {getStreetNumber()}, {address.complement ? `${address.complement},` : ''} Bairro {address.neighborhood}, na
          Cidade de {address.city}, Estado {statePreposition(address.state)} {address.state}, CEP {postalCode}, neste
          ato representada por <b>{legalRepresentativeName}</b>, {nationality}, {maritalStatus.name}, portador(a) da
          carteira de identidade RG nº {rg} {orgaoEmissor}, inscrito no CPF/MF sob o nº {cpf}, correio eletrônico{' '}
          {legalRepresentativeEmail}, com domicílio comercial no endereço da pessoa jurídica acima qualificada,
          doravante designada apenas como <b>"CONTRATADA"</b>.
        </>
      )
    }
    return (
      <>
        e do outro lado, <b> {businessName} </b>, inscrita no CNPJ/MF sob o nº {cnpj} com sede na {street},{' '}
        {getStreetNumber()}, {complement ? `${complement},` : ''} Bairro {neighborhood}, na Cidade de {city}, Estado{' '}
        {statePreposition(getState())} {getState()}, CEP {postalCode}, neste ato representada por
        <b>{legalRepresentativeName}</b>, {nationality}, {maritalStatus.name}, portador(a) da carteira de identidade RG
        nº {rg} {orgaoEmissor}, inscrito no CPF/MF sob o nº {cpf}, correio eletrônico {legalRepresentativeEmail}, com
        domicílio comercial no endereço da pessoa jurídica acima qualificada, doravante designada apenas como{' '}
        <b>"CONTRATADA"</b>.
      </>
    )
  }

  return (
    <View pageBreakAfter>
      <Table justify="space-between" center width={'100%'}>
        <TableRow style={{ align: 'center' }}>
          <TableHeadText align={'center'}>
            {`TERMO DE RESILIÇÃO BILATERAL DO CONTRATO DE PRESTAÇÃO DE SERVIÇOS CELEBRADO ENTRE AS PARTES EM ${toDateFormat(
              startDate,
              'DD/MM/YYYY'
            )}.`}
          </TableHeadText>
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Text size="small" align="justify">
        Pelo presente instrumento particular, as Partes, denominadas individualmente <b>"Parte"</b> e, em conjunto,
        <b> "Partes"</b>:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        {contractorData}
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        {addressData()}
      </Text>
      <Separator weight={4} />
      <Text bold size="small">
        PRELIMINARMENTE – QUADRO RESUMO
      </Text>
      <Separator weight={4} />
      <Table justify="space-between" center width={'100%'}>
        <TableRow style={{ align: 'center' }}>
          <TableHeadText align={'center'}>CLÁUSULA</TableHeadText>
          <TableHeadText align={'center'}>PREVISÃO</TableHeadText>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 3ª – Pagamento</Text>
          </TableCol>
          <TableCol>
            <Text size="small">Comissões devidas conforme contrato, apuradas mês a mês</Text>
          </TableCol>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 5ª – Vigência</Text>
          </TableCol>
          <TableCol>
            <Text size="small">{toDateFormat(endDate, 'DD/MM/YYYY')}</Text>
          </TableCol>
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Text size="small" align="justify">
        Isto posto, as Partes, de comum acordo e na melhor forma de direito, resolvem celebrar o presente{' '}
        <i>
          <b>Termo de Resilição Bilateral</b>
        </i>
        , nas condições previstas neste instrumento, como de fato resilido têm, o instrumento em referência, o que fazem
        segundo as considerações acima e as cláusulas e condições que mutuamente outorgam e aceitam, conforme segue:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>Cláusula 1ª:</b> Fica formalizada pelo presente instrumento, a Resilição Bilateral do{' '}
        <i>"Instrumento Particular de Contrato de Prestação de Serviços"</i>, firmado pelas Partes em{' '}
        {toDateFormat(startDate, 'DD/MM/YYYY')}.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>Cláusula 2ª:</b> Neste ato, a título de acerto final de contas por toda a prestação de serviços realizados
        pela Contratada até a presente data, a CONTRATANTE efetuará o pagamento do valor devido à CONTRATADA da seguinte
        forma:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>§1º:</b> As Comissões que lhes são devidas pelos serviços contratados, conforme estabelecido no{' '}
        <i>"Instrumento Particular de Contrato de Prestação de Serviços"</i>, serão apuradas mês a mês, sendo os valores
        apurados pagos à CONTRATADA até o último dia de cada mês.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>§2º:</b> Não entrará no cálculo de Comissões que trata o item anterior, os contratos que tenham sido
        cancelados e os inadimplentes declarando a CONTRATADA ter pleno e total conhecimento, concordando com todos os
        termos do presente "Termo de Resilição Bilateral".
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>Cláusula 3ª:</b> Os pagamentos previstos na Cláusula 2ª serão efetuados através de transferência bancária
        para crédito em conta corrente de titularidade da CONTRATADA, mediante a apresentação da correspondente Nota
        Fiscal.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>Cláusula 4ª – Da Validade do Documento Eletrônico:</b> As Partes reconhecem a veracidade, autenticidade,
        integridade, validade e eficácia desta Resilição e seus termos, nos moldes do art. 219 do Código Civil, bem como
        a aposição das respectivas assinaturas eletrônicas nesta Resilição, em plataforma digital com certificação ICP
        Brasil.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>Parágrafo único:</b> As Partes responsabilizam-se direta e ilimitadamente pelas informações prestadas a
        respeito de suas representações legais, atestando que as pessoas informadas para a emissão de assinatura
        eletrônica na plataforma de certificação ICP Brasil são legitimadas e possuem poderes expressos para celebrar
        esta Resilição.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>Cláusula 5ª – Da Vigência:</b> O presente “Termo de Resilição Bilateral” é celebrado na data de sua
        assinatura, sendo reconhecida a finalização da prestação de serviços desde a data de{' '}
        {toDateFormat(endDate, 'D [de] MMMM [de] YYYY')}, quando passou a surtir todos os seus efeitos.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        O presente instrumento poderá ser firmado através de assinatura eletrônica, devidamente regulamentada pela
        Medida Provisória 2.200-2/2001, com a qual as partes declaram ciência e concordância.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        E, por estarem assim justas e contratadas, as Partes assinam este Termo de Resilição Bilateral, na presença de 2
        (duas) testemunhas que também o subscrevem, para que produza todos os seus jurídicos e legais efeitos.
      </Text>

      <Separator weight={4} />
      <Table center color={'transparent'} justify="center">
        <TableRow color={'transparent'} style={{ align: 'center' }} width={'100%'}>
          <Text size="small" align="justify">
            Fortaleza (CE), {now}.
          </Text>
        </TableRow>
      </Table>

      <Separator weight={4} />
      <Text size="small" bold>
        PELA CONTRATANTE:
      </Text>
      <Separator weight={8} />
      <Line color={'black'} />
      <Table center color={'transparent'} justify="center">
        <TableRow color={'transparent'} style={{ align: 'center' }} width={'100%'}>
          <Text size="small" bold align={'center'}>
            {signatureText(findReplyByQuestionId(replies, 138))}
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" align={'center'}>
            CNPJ/MF sob o nº {contractorCNPJ}
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" italic align={'center'}>
            (Assinado eletronicamente)
          </Text>
        </TableRow>
      </Table>
      <Separator weight={8} />
      <Text size="small" bold>
        PELA CONTRATADA:
      </Text>
      <Separator weight={8} />
      <Line color={'black'} />
      <Table center color={'transparent'}>
        <TableRow color={'transparent'}>
          <Text size="small" bold align={'center'}>
            {businessName.toUpperCase()}
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" align={'center'}>
            CNPJ/MF sob o nº {cnpj}
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" italic align={'center'}>
            ({legalRepresentativeName})
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" italic align={'center'}>
            (Assinado eletronicamente)
          </Text>
        </TableRow>
      </Table>
      <Separator weight={8} />
      <Text size="small" bold>
        Testemunhas:
      </Text>
      <Table color={'transparent'} width={'100%'}>
        <TableCol color={'transparent'}>
          <Table color={'transparent'} width={'100%'}>
            <TableRow>
              <Text size="small">1)</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">Nome:</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">CPF:</Text>
            </TableRow>
          </Table>
        </TableCol>
        <TableCol color={'transparent'}>
          <Table color={'transparent'} width={'100%'}>
            <TableRow>
              <Text size="small">2)</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">Nome:</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">CPF:</Text>
            </TableRow>
          </Table>
        </TableCol>
      </Table>
    </View>
  )
}

export default TerminationContent
